<template>
  <div class="navbar-menus">
    <el-menu
      mode="horizontal"
      @select="handleSelect"
    >
      <div
        v-for="menu in menus"
        :key="menu.key"
      >
        <el-menu-item
          v-if="menu.children.length === 1"
          :index="menu.children[0].name"
          :class="activeMenu.key === menu.key ?'is-active' : ''"
        >
          <div>
            <i
              v-if="menu.children[0].meta.icon"
              :class="menu.children[0].meta.icon"
            />
            <i
              v-else
              :class="menu.icon"
            />
            {{ menu.label }}
          </div>
        </el-menu-item>
        <el-submenu
          v-else
          :index="menu.key"
          :class="activeMenu.key === menu.key ?'is-active' : ''"
        >
          <template slot="title">
            <span>
              <i :class="menu.icon" />{{ menu.label }}
            </span>
          </template>
          <el-menu-item
            v-for="item in menu.children"
            :key="item.name"
            :index="item.name"
            :class="selectedRouter.name === item.name ? 'is-active' : ''"
          >
            <div style="display: flex; align-items: center;">
              <i
                v-if="menu.showIcon"
                :class="item.meta.icon"
              />{{ item.meta.title }}
            </div>
          </el-menu-item>
        </el-submenu>
      </div>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GROUP_KEYS } from '@/config/constants';
export default {
  name: 'Menus',
  components: {
  },
  computed: {
    ...mapGetters("config", ["allConfigs"]),
    routers() {
      return this.$router.options.routes.filter((r) => r.layout === "root").map((r) => ({
        ...r,
        ...r.children[0]
      }));
    },
    objectConfigs() {
      return this.allConfigs.filter((c) => c.type !== "categories")
    },
    moduleConfigs() {
      return this.objectConfigs.filter((c) => c.extra.modules?.length > 0)
    },
    otherConfigs() {
      return this.objectConfigs.filter((c) => c.extra.modules?.length <= 0)
    },
    menus() {
      return [
        {
          key: GROUP_KEYS.DASHBOARD,
          icon: 'el-icon-menu',
          label: 'Trang chủ',
          children: this.routers.filter((r) => r.meta.group === GROUP_KEYS.DASHBOARD)
        },
        ...this.moduleConfigs.map((c) => ({
          key: c.extra.key,
          icon: c.extra?.info?.icon,
          label: c.extra.name,
          children: this.routers.filter((r) => r.meta.group === c.extra.key)
        })),
        {
          key: GROUP_KEYS.CATEGORIES,
          icon: 'el-icon-folder',
          label: 'Danh mục',
          children: this.routers.filter((r) => r.meta.group === GROUP_KEYS.CATEGORIES)
        },
        {
          key: GROUP_KEYS.APPROVED_DOCUMENTS,
          icon: 'el-icon-finished',
          label: 'Phê duyệt',
          children: this.routers.filter((r) => r.meta.group === GROUP_KEYS.APPROVED_DOCUMENTS)
        },
        {
          key: GROUP_KEYS.MANAGE,
          icon: 'el-icon-s-management',
          label: 'Quản trị',
          children: this.routers.filter((r) => r.meta.group === GROUP_KEYS.MANAGE)
        },
        {
          key: GROUP_KEYS.LOG,
          icon: 'el-icon-time',
          label: 'Lịch sử',
          children: this.routers.filter((r) => r.meta.group === GROUP_KEYS.LOG)
        },
        {
          key: GROUP_KEYS.OTHER,
          icon: 'el-icon-s-operation',
          label: 'Danh mục khác',
          showIcon: true,
          children: this.routers.filter((r) => r.meta.group === GROUP_KEYS.OTHER || this.otherConfigs.map((c) => c.extra.key).includes(r.meta.group))
        },
      ].filter((m) => m.children.length > 0)
    },
    selectedRouter() {
      const route = this.$route;
      const { name, meta } = route;
      return this.routers.find((r) => {
        if (meta.parent) {
          return r.name === meta.parent
        }
        return r.name === name
      });
    },
    activeMenu() {
      return this.menus.find((m) => !!m.children.find((c) => c.name === this.selectedRouter.name))
    }
  },
  methods: {
    handleSelect(key) {
      this.$router.push({ name: key });
    }
  },
};
</script>

<style lang="scss">
.navbar-menus {
  .el-menu--horizontal {
    display: flex;
    background-color: transparent;
    color: #4F4F4F;
    .el-menu-item {
      color: #4F4F4F;
      padding: 0 16px;
      font-weight: bold;
      i {
        color: #4F4F4F;
      }
      &.is-active, &:hover {
        background-color: #ffffff;
        color: #4F4F4F !important;
        i {
          color: #4F4F4F !important;
        }
      }
    }
    .el-submenu {
      &__title {
        color: #4F4F4F;
        font-weight: bold;
        padding: 0 16px;
        > span {
          padding-right: 24px;
        }
        i {
          color: #4F4F4F;
        }
        &:hover {
          background-color: #c9cdd74e;
          color: #4F4F4F !important;
          i {
            color: #4F4F4F !important;
          }
        }
        .el-submenu__icon-arrow {
          color: #4F4F4F;
          font-weight: bold;
          margin-top: -5px;
        }
      }
      &.is-active {
        .el-submenu__title {
          background-color: #ffffff;
          color: #4F4F4F !important;
          i {
            color: #4F4F4F !important;
          }
        }
      }
    }
  }
}
.el-menu--horizontal {
  .el-menu--popup {
    .el-menu-item {
      font-size: 16px;
      height: 40px;
      line-height: 40px;
      font-weight: 600;
      color: #2b2f3a;
      i {
        color: #2b2f3a;
      }
      &.is-active, &:hover {
        background-color: #c9cdd74e;
      }
    }
  }
}
</style>
